import Vue from 'vue';
import inputmask from 'inputmask';
import { VBModal, VBTooltip } from 'bootstrap-vue';
import debounce from 'v-debounce';
// --------------------------------------------
// Register a global bootstrap-vue directives
// --------------------------------------------
Vue.directive('b-tooltip', VBTooltip);
Vue.directive('b-modal', VBModal);
// Register v-debounce directive
Vue.directive('debounce', debounce);
// -------------------------------------
// Register a global custom directives
// -------------------------------------
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted(el) {
    // Focus the element
    el.focus();
  }
});
// Added a new alias 'euro' into Inputmask
inputmask.extendAliases({
  euro: {
    suffix: ' €',
    groupSeparator: '.',
    radixPoint: ',',
    alias: 'numeric',
    placeholder: '0',
    autoGroup: true,
    digits: 2,
    digitsOptional: false,
    clearMaskOnLostFocus: true,
    autoUnmask: true,
    unmaskAsNumber: true,
    rightAlign: false
  }
});
// Added a directive 'mask' for ald-input component
Vue.directive('mask', {
  bind(el, binding) {
    if (binding.value) inputmask(binding.value).mask(el);
  }
});
Vue.filter('capitalize', value => {
  if (!value) return '';
  return value
    .toString()
    .replace(/[A-zÀ-ú0-9]\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
});
Vue.filter('lowercase', value => {
  if (!value) return '';
  return value.toString().toLowerCase();
});
Vue.filter('uppercase', value => {
  if (!value) return '';
  return value.toString().toUpperCase();
});
Vue.filter('first-letter', value => {
  if (!value) return '';
  return (
    value
      .toString()
      .charAt(0)
      .toUpperCase() + value.toString().slice(1)
  );
});
Vue.filter('trim-and-uppercase', value => {
  if (!value) return '';
  return value
    .replace(/\s/g, '')
    .trim()
    .toUpperCase();
});
